/* eslint-disable */
import { GetterTree } from "vuex";
import { State } from "@/store/state";

export type Getters = {
};

export const getters: GetterTree<State, State> & Getters = {};
